// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".styles-module__Container__3fT5s{margin-top:56px;scroll-behavior:smooth}", ""]);
// Exports
exports.locals = {
	"Container": "styles-module__Container__3fT5s"
};
export default exports;
